import React, { useEffect,useRef,useState } from "react"; 
import { useNavigate } from 'react-router-dom';

import { isNull,ToggleDarkBackground } from "../../../components/common/Common";

import gnbIcon from "../../../img/icon/icon-gnb-close.svg";
import noBranchImage from "../../../img/icon/icon-loca.svg";
import menu1Icon from "../../../img/icon/icon-gnb-01.svg";
import menu3Icon from "../../../img/icon/icon-gnb-03.svg";
import menu6Icon from "../../../img/icon/icon-gnb-06.svg";
import menu7Icon from "../../../img/icon/icon-gnb-07.svg";
import menu8Icon from "../../../img/icon/icon-gnb-08.svg";
import menu11Icon from "../../../img/icon/icon-gnb-11.svg";
import menu14Icon from "../../../img/icon/icon-gnb-14.svg";


//좌측메뉴
const MenuBranch = ({varMenuState,setMenuState}) => {
  const navigate = useNavigate();
  const menuRef = useRef();
  
  const branchLoginState = Number(localStorage.getItem("branchLoginState"));
  const branchName = localStorage.getItem("branch_name");
  const branchCompany = localStorage.getItem("branch_company");

  const [varProfileImage,setProfileImage] = useState(null);
  const [varBranchImage,setBranchImage] = useState(null);

  useEffect(() => {
    //센터 사진
    const branchImage = Number(localStorage.getItem("branch_image"));
    const branchPhotos = localStorage.getItem("branch_photo");
    if(!isNull(branchPhotos) && branchImage===1) setBranchImage(`${process.env.REACT_APP_HOST}/branch/${branchPhotos}`);
    else setBranchImage(noBranchImage);

    if(varMenuState) {
      /* const leftMenu = document.querySelector('gnb-left-wrap');
      leftMenu.scrollTop = 0; */
      if(!menuRef.current.classList.contains("open")) menuRef.current.classList.add('open');
      ToggleDarkBackground(true);
    } else {
      if(menuRef.current.classList.contains("open")) menuRef.current.classList.remove('open');
      ToggleDarkBackground(false);
    }
    //점주사진
    SetBranchMemberImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varMenuState]);

  useEffect(() => {
    SetBranchMemberImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("member_photo")]);

  //점주사진
  const SetBranchMemberImage =() =>{
    const branchMemberImage = Number(localStorage.getItem("branch_mem_image"));
    const branchMemberPhotos = localStorage.getItem("branch_mem_photo");
    if(!isNull(branchMemberPhotos) && branchMemberImage===1) setProfileImage(`${process.env.REACT_APP_HOST}/member/${branchMemberPhotos}`);
  }

  //메뉴선택시
  const onLinkPageHandler = (e,imenu) => {
    if(branchLoginState === 0) {
      alert('로그인이 필요한 화면입니다.');
      setMenuState(false);
      navigate('/LoginBranch');
    } else {
      let menuName = "";
      switch (imenu) {
        case 1: menuName="/Branch/ClassSet"; localStorage.removeItem('semesterIndex'); break;
        case 2: menuName="/Branch/ReinForceSet"; break;
        case 3:
        case 6:
          const subListBox = e.currentTarget.parentNode.querySelector('.gnb-submenu');
          console.log('c',subListBox);
          if(subListBox.classList.contains('hide')) subListBox.classList.remove('hide');
          else subListBox.classList.add('hide');
          break;
        case 4: menuName="/Branch/AnalysisSet"; break;
        case 5: menuName="/Branch/SettlementSet"; break;
        case 7: menuName="/Branch/Setting"; break;
        default: menuName="/MainBranch"; break;
      }
      if(imenu !== 3 && imenu !== 6){
        setMenuState(false);
        navigate(menuName);
      } 
    }
  }

  //서브메뉴
  const onLinkSubPageHandler = (e,ino) => {
    console.log('b',ino)
    let menuName = "";
    switch (ino) {
      case 1: menuName="/Branch/ParentSet"; break;
      case 2: menuName="/Branch/InvoiceSet"; break;
      case 3: menuName="/Branch/TextBookOrder"; break;
      case 4: menuName="/Branch/CertificatesSet"; break;
      case 5: menuName="/Branch/PaymentSet"; break;
      case 6: menuName="/Branch/SalesReport"; break;
      case 7: menuName="/Branch/Operating"; break;
      default: menuName="/MainBranch"; break;
    }
    const subListBox = e.currentTarget.parentElement;
    console.log('a',subListBox)
    if(!subListBox.classList.contains('hide')) subListBox.classList.add('hide');
    setMenuState(false);
    navigate(menuName);
  }

  //메뉴닫기
  const onCloseMenuHandler = (e) => {
    setMenuState(false);
  }
  const onGotoPageHandler = (e,spage) => {
    setMenuState(false);
    navigate(spage);
  }

  return (
    <div className="gnb-left-wrap" ref={menuRef}>
      <div className="gnb-left-all">
        <div className="gnb-left">
          <div className="gnb-left-head">
            <div className="btn-close" onClick={e=>onCloseMenuHandler(e)}><img src={gnbIcon} alt=""/></div>
            <p>메뉴</p>
          </div>
          <div className="gnb-left-body">
            <div className="gnb-profile" onClick={e=>onGotoPageHandler(e,'/Branch/BranchInfo')}>
              <div className="gnb-pro-line">
                <div className="gnb-profile-img"><img src={varProfileImage} alt="" /></div>
                <div className="gnb-profile-info">
                  <div className="gnb-profile-name">{branchName}</div>
                  <div className="gnb-profile-center"><img src={varBranchImage} alt=""/>{branchCompany}</div>
                </div>
              </div>
            </div>
            <div className="gnb-menu-list">
              <ul>
                <li onClick={e=>onLinkPageHandler(e,1)}>
                  <div className="gnb-menu-link">
                    <div className="gnb-menu-icon"><img src={menu1Icon} alt=""/></div>
                    <div className="gnb-menu-text">클래스 설정</div>
                  </div>
                </li>
                <li onClick={e=>onLinkPageHandler(e,2)}>
                  <div className="gnb-menu-link">
                    <div className="gnb-menu-icon"><img src={menu6Icon} alt=""/></div>
                    <div className="gnb-menu-text">보강 수업</div>
                  </div>
                </li>
                <li>
                  <div className="gnb-menu-link" onClick={e=>onLinkPageHandler(e,3)}>
                    <div className="gnb-menu-icon"><img src={menu3Icon} alt=""/></div>
                    <div className="gnb-menu-text">원생 관리</div>
                  </div>
                  <ul className="gnb-submenu hide">
                      <li onClick={e=>onLinkSubPageHandler(e,1)}>학부모/원생관리</li>
                      <li onClick={e=>onLinkSubPageHandler(e,2)}>원생수업배정(청구서발송)</li>
                    </ul>
                </li>
                {/* <li onClick={()=>onLinkPageHandler(5)}>
                  <div className="gnb-menu-link">
                    <div className="gnb-menu-icon"><img src={menu5Icon} alt=""/></div>
                    <div className="gnb-menu-text">참여 수업</div>
                  </div>
                </li> */}
                <li onClick={e=>onLinkPageHandler(e,4)}>
                  <div className="gnb-menu-link">
                    <div className="gnb-menu-icon"><img src={menu7Icon} alt=""/></div>
                    <div className="gnb-menu-text">발달 분석 및 평가</div>
                  </div>
                </li>
                <li onClick={e=>onLinkPageHandler(e,5)}>
                  <div className="gnb-menu-link">
                    <div className="gnb-menu-icon"><img src={menu11Icon} alt=""/></div>
                    <div className="gnb-menu-text">정산 현황</div>
                  </div>
                </li>
                <li>
                  <div className="gnb-menu-link" onClick={e=>onLinkPageHandler(e,6)}>
                    <div className="gnb-menu-icon"><img src={menu8Icon} alt=""/></div>
                    <div className="gnb-menu-text">운영 관리</div>
                  </div>
                  <ul className="gnb-submenu hide">
                    <li onClick={e=>onLinkSubPageHandler(e,3)}>교재 주문</li>
                    <li onClick={e=>onLinkSubPageHandler(e,4)}>수료증</li>
                    <li onClick={e=>onLinkSubPageHandler(e,5)}>결제 관리</li>
                    <li onClick={e=>onLinkSubPageHandler(e,6)}>매출 리포트</li>
                    <li onClick={e=>onLinkSubPageHandler(e,7)}>정보 관리</li>
                  </ul>
                </li>
                <li onClick={e=>onLinkPageHandler(e,7)}>
                  <div className="gnb-menu-link">
                    <div className="gnb-menu-icon"><img src={menu14Icon} alt=""/></div>
                    <div className="gnb-menu-text">설정</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="gnb-right" onClick={e=>onCloseMenuHandler(e)}></div>
      </div>
    </div>
  )
}
export default MenuBranch;
